import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has stopped changing for `delayMs`. Used to throttle
 * server-side search so we fire one query per pause, not one per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
